import { gql } from '@apollo/client';

export const NEW_USER = gql`
  mutation ($input: UserCreateInput!) {
    createUser(input: $input) {
      id
    }
  }
`;
